import SupplierOrders from '../supplierOrders/supplierOrders';
export default function SupplierOrdersTab(props) {

    const projectId = props.projectId
return (
    <div>
        <SupplierOrders isInProject = {true} projectId = {projectId}></SupplierOrders>
    </div>
)};